<br><br><br><br>
<div class="page-title">
  <h1 class="title-text">IT Form List</h1>
  <p class="form-desc">
    View and manage IT forms below.
  </p>
</div>
<br />
<div class="form-hub-container">
  <div class="search-container">
    <mat-form-field class="search-input">
      <mat-label>Search...</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="" #filterInput>
    </mat-form-field>
  </div>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <!-- Form Name Column -->
    <ng-container matColumnDef="employeeName">
      <th mat-header-cell *matHeaderCellDef>Requesting Employee</th>
      <td mat-cell *matCellDef="let element">{{ element.section1.employeeName }}</td>
    </ng-container>

    <!-- Form Date Column -->
    <ng-container matColumnDef="requestDate">
      <th mat-header-cell *matHeaderCellDef>Request Date</th>
      <td mat-cell *matCellDef="let element">{{ element.section1.requestDate | date:'M/d/yyyy' }}</td>
    </ng-container>

    <!-- Link Column -->
    <ng-container matColumnDef="formLink">
      <th mat-header-cell *matHeaderCellDef>Link</th>
      <td mat-cell *matCellDef="let element">
        <a [routerLink]="['/computer-request-form', element._id]" routerLinkActive="active">View Form</a>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="formStatus">
      <th mat-header-cell *matHeaderCellDef>Form Status</th>
      <td mat-cell *matCellDef="let element">{{ element.formStatus }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
  </table>

  <!-- No Data Available -->
  @if (dataSource.filteredData.length === 0) {
    <div class="no-data-message">
      <mat-icon color="primary">info</mat-icon>
      <span>No computer request forms available.</span>
    </div>
  }
</div>
